import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.692 2a4.307 4.307 0 0 0-3.046 1.254L9 3.896l-.647-.642A4.307 4.307 0 0 0 5.307 2a4.308 4.308 0 0 0-3.046 1.254 4.26 4.26 0 0 0 0 6.052L9.001 16l6.737-6.694a4.258 4.258 0 0 0 0-6.052A4.307 4.307 0 0 0 12.692 2Zm0 2c.62 0 1.2.238 1.637.672.432.431.671 1.001.671 1.607 0 .607-.239 1.178-.67 1.608L9 13.181 3.671 7.887a2.251 2.251 0 0 1-.67-1.608c0-.606.237-1.176.67-1.607A2.302 2.302 0 0 1 5.307 4c.62 0 1.2.238 1.637.672l.646.642L9 6.715l1.41-1.401.645-.642A2.306 2.306 0 0 1 12.692 4Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
